import React, { useState, useEffect } from "react";
import {
  Articles,
  getArticlesAndProfilePictureFromDatabase,
} from "./articleHelpers";
import CircularProgress from "@mui/material/CircularProgress";
import SignedIn from "./SignedIn";

type SignedInWrapperProps = {
  signOut: (data?: Record<string | number | symbol, any> | undefined) => void;
  user: any;
};

const SignedInWrapper: React.FC<SignedInWrapperProps> = ({ signOut, user }) => {
  const [articlesFromDb, setArticlesFromDb] = useState<Articles>();
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>();

  useEffect(() => {
    const retrieveArticles = async () => {
      try {
        const { articles, profilePictureUrl } =
          await getArticlesAndProfilePictureFromDatabase();
        setProfilePictureUrl(profilePictureUrl);
        setArticlesFromDb(articles);
      } catch (e) {
        alert(e);
        setArticlesFromDb({});
      }
    };
    retrieveArticles();
  }, []);

  return articlesFromDb ? (
    <SignedIn
      signOut={signOut}
      user={user}
      articlesFromDb={articlesFromDb}
      profilePictureUrl={profilePictureUrl}
      setProfilePictureUrl={setProfilePictureUrl}
    />
  ) : (
    <CircularProgress sx={{ margin: "auto" }} />
  );
};

export default SignedInWrapper;
